import React from "react";
import _ from "lodash";
import PublisherInfoHeader from "components/ops-mgmt/account/network-features/PublisherInfoHeader";
import ViewerWrapper from "components/common/ViewerWrapper";
import StepProgress from "components/common/StepProgress";
import OnboardAccount from "./OnboardAccount";
import OnboardNetwork from "./OnboardNetwork";
import OnboardYieldSet from "./OnboardYieldSet";
import OnboardAdUnits from "./OnboardAdUnits";
import OnboardSummary from "./OnboardSummary";
import MessageText from "components/common/MessageText";
import { MESSAGE } from "constants/Message";

import { buttonModalConfirmClass } from "helpers/StyleClass";

const STEP = {
  GAM_ACCOUNT: "GAM Account",
  ONBOARD_NETWORK: "Onboard Network",
  ONBOARD_YIELD_SET: "Onboard Yield Set",
  ONBOARD_AD_UNITS: "Onboard Ad Units",
  DONE: "Summary & Configs",
};

const PROBLEM = {
  NORMAL: "NORMAL",
  UNAUTHORIZED: "UNAUTHORIZED",
};

const STEPS = _.values(STEP);

class OnboardInventoryView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      msg: [],

      publisherId: null,
      selectedAccount: null,
      selectedNetwork: null,
      selectedYieldSet: null,

      currentStep: 1,
    };

    this.handlePrevious = this.handlePrevious.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleValidate = this.handleValidate.bind(this);
    this.handleFinish = this.handleFinish.bind(this);
  }

  async componentDidMount() {
    const { publisherId } = this.props.match.params;
    this.setState({ publisherId });
  }

  handlePrevious() {
    const { currentStep, selectedYieldSet } = this.state;
    this.setState({ msg: [] });

    if (currentStep === 5 && !selectedYieldSet) {
      this.setState({
        currentStep: 2,
      });
      return;
    }

    this.setState((prevState) => ({
      currentStep: Math.max(prevState.currentStep - 1, 1),
    }));
  }

  handleNext() {
    if (this.handleValidate()) {
      this.setState((prevState) => ({
        currentStep: Math.min(prevState.currentStep + 1, STEPS.length),
      }));
    }
  }

  handleFinish() {
    if (this.handleValidate()) {
      this.setState({
        currentStep: 5,
      });
    }
  }

  handleReset() {
    this.setState({
      currentStep: 1,
      selectedAccount: null,
      selectedNetwork: null,
      selectedYieldSet: null,
    });
  }

  handleValidate() {
    const { currentStep, selectedAccount, selectedNetwork, selectedYieldSet } =
      this.state;

    this.setState({ msg: [] });

    if (currentStep === 1) {
      if (!selectedAccount) {
        this.setState({ msg: ["Please select one account", MESSAGE.ERROR] });
        return false;
      }

      if (selectedAccount.problems.indexOf(PROBLEM.UNAUTHORIZED) !== -1) {
        this.setState({
          msg: ["This account need to be authorized first", MESSAGE.ERROR],
        });
        return false;
      }
    }

    if (currentStep === 2) {
      if (!selectedNetwork) {
        this.setState({ msg: ["Please select one network", MESSAGE.ERROR] });
        return false;
      }
    }

    if (currentStep === 3) {
      if (!selectedYieldSet) {
        this.setState({ msg: ["Please select one yield set", MESSAGE.ERROR] });
        return false;
      }
    }

    return true;
  }

  render() {
    const {
      publisherId,
      currentStep,
      isLoading,
      selectedAccount,
      selectedNetwork,
      selectedYieldSet,
      msg,
    } = this.state;

    const info = () => {
      return [
        selectedAccount && currentStep > 1
          ? `${selectedAccount.accountId} - ${selectedAccount.name}`
          : null,
        selectedNetwork && currentStep > 2
          ? `${selectedNetwork.networkId} - ${selectedNetwork.name}`
          : null,
        selectedYieldSet && currentStep > 3
          ? `${selectedYieldSet.yieldSetId} - ${selectedYieldSet.name}`
          : null,
        null,
        null,
      ];
    };

    return (
      <>
        {publisherId && (
          <PublisherInfoHeader pubId={publisherId}></PublisherInfoHeader>
        )}
        <ViewerWrapper
          title="Onboard Inventory"
          height="calc(100vh - 9.66rem)"
          isLoading={isLoading}
        >
          <div className="flex h-full flex-col items-center gap-2">
            <div className="w-3/5">
              <StepProgress
                steps={STEPS}
                info={info()}
                currentStep={currentStep}
              ></StepProgress>
            </div>

            <div className="mt-10 w-3/4" style={{ height: "75%" }}>
              {publisherId && (
                <div
                  className="overflow-y-auto"
                  style={{ maxHeight: "calc(100% - 5rem)" }}
                >
                  {currentStep === 1 && (
                    <OnboardAccount
                      selectedAccount={selectedAccount}
                      pubId={publisherId}
                      handleLoading={(isLoading) =>
                        this.setState({ isLoading })
                      }
                      handleChange={(account) =>
                        this.setState({ selectedAccount: account })
                      }
                    ></OnboardAccount>
                  )}
                  {currentStep === 2 && (
                    <OnboardNetwork
                      selectedNetwork={selectedNetwork}
                      accountId={selectedAccount.accountId}
                      networks={selectedAccount.gamNetworks}
                      handleLoading={(isLoading) =>
                        this.setState({ isLoading })
                      }
                      handleChange={(network) =>
                        this.setState({ selectedNetwork: network })
                      }
                    ></OnboardNetwork>
                  )}
                  {currentStep === 3 && (
                    <OnboardYieldSet
                      selectedYieldSet={selectedYieldSet}
                      networkId={selectedNetwork.networkId}
                      handleLoading={(isLoading) =>
                        this.setState({ isLoading })
                      }
                      handleChange={(account) =>
                        this.setState({ selectedYieldSet: account })
                      }
                    ></OnboardYieldSet>
                  )}
                  {currentStep === 4 && (
                    <OnboardAdUnits
                      networkId={selectedNetwork.networkId}
                      yieldSetId={selectedYieldSet.yieldSetId}
                    ></OnboardAdUnits>
                  )}
                  {currentStep === 5 && (
                    <OnboardSummary
                      publisherId={publisherId}
                      selectedAccount={selectedAccount}
                      selectedNetwork={selectedNetwork}
                      selectedYieldSet={selectedYieldSet}
                      handleLoading={(isLoading) =>
                        this.setState({ isLoading })
                      }
                      handleChangeAccount={(account) =>
                        this.setState({ selectedAccount: account })
                      }
                      handleChangeNetwork={(network) =>
                        this.setState({ selectedNetwork: network })
                      }
                    ></OnboardSummary>
                  )}
                </div>
              )}

              <div
                className={`${
                  [2].indexOf(currentStep) !== -1 ? "w-3/4" : "w-full"
                } mx-auto mb-2 mt-4`}
              >
                <MessageText msg={msg}></MessageText>
              </div>

              <div className="flex w-full items-center justify-center gap-4">
                {currentStep > 1 && (
                  <button
                    type="button"
                    className={buttonModalConfirmClass}
                    onClick={this.handlePrevious}
                  >
                    Previous
                  </button>
                )}

                {currentStep < STEPS.length ? (
                  <button
                    type="button"
                    className={buttonModalConfirmClass}
                    onClick={this.handleNext}
                  >
                    Next
                  </button>
                ) : (
                  <button
                    type="button"
                    className={buttonModalConfirmClass}
                    onClick={this.handleReset}
                  >
                    Done
                  </button>
                )}

                {currentStep === 2 && (
                  <div className="relative">
                    <button
                      type="button"
                      className={buttonModalConfirmClass}
                      onClick={this.handleFinish}
                    >
                      Skip to Step 5
                    </button>
                    <div
                      className="absolute text-sm text-gray-700"
                      style={{ width: "18rem" }}
                    >
                      *Yield Sets and Ad Units can be onboarded later
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </ViewerWrapper>
      </>
    );
  }
}

export default OnboardInventoryView;
